@if (areAnyCardsVisible()) {
    @if (deckCards.length == 1) {
        <magic-deck-row 
            (mouseenter)="onCardHover(deckCards[0])"
            [isOwnDeck]="isOwnDeck"
            [deck]="deck"
            [deckComponent]="deckComponent"
            [deckLayerComponent]="deckLayerComponent"
            [deckGroupComponent]="deckGroupComponent"
            [deckMultiRowComponent]="this"
            [deckCard]="deckCards[0]" 
            class="table-row text-sm group hover:bg-ponder-linkhover hover:bg-opacity-15"></magic-deck-row>
    } @else if (deckCards.length > 1) {
        <div class="flex flex-col relative" [ngClass]="{ 'bg-slate-100 bg-opacity-50 shadow-md rounded-b' : shouldShowChildren() }">
            <div 
                (click)="onToggleChildrenClicked()" 
                (mouseenter)="onCardHover(deckCards[0])" 
                class="flex flex-row items-center gap-[1ch] border-t border-ponder-light border-opacity-10 hover:bg-ponder-linkhover hover:bg-opacity-15 hover:cursor-pointer text-xs sm:text-sm" 
                [ngClass]="{ 'bg-slate-100 bg-opacity-70' : shouldShowChildren() }">
                <div class="text-slate-800 text-opacity-50 text-center w-[3ch]">
                    @if (getCollectedCount()) {
                        {{ getCollectedCount() }}
                    }
                </div>
                <div class="w-[2ch] text-center text-xs sm:text-sm" [ngClass]="{ 'text-foil-dark' : areAllChildrenFoil }">
                    {{ getTotalCount() }}
                </div>
                <div class="w-[20ch] truncate text-xs sm:text-sm" [ngClass]="{ 'text-foil-dark' : areAllChildrenFoil }">
                    {{ getCardName() }}
                </div>
                <div class="w-[12ch] items-end justify-end grow">
                    <!-- mana value placeholder -->
                </div>
                <div class="w-[6ch] truncate text-xs text-slate-400">
                    {{ getTotalValue() }}
                </div>
                <div class="align-middle">
                    <div class="flex justify-end">
                        <div class="w-6">
                            <svg class="pl-1 w-5 h-5 fill-none stroke-ponder-light" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                @if (!shouldShowChildren()) {
                                    <title>Expand</title>
                                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="expandSvgIcon" />
                                } @else {
                                    <title>Collapse</title>
                                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="collapseSvgIcon" />
                                }
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-col">
                @for (deckCard of deckCards ; track deckCard.card.item.id!) {
                    @if (deckComponent.isCardVisible(deckCard)) {
                        <magic-deck-row 
                            (mouseenter)="onCardHover(deckCard)"
                            [isOwnDeck]="isOwnDeck"
                            [deck]="deck"
                            [deckComponent]="deckComponent"
                            [deckLayerComponent]="deckLayerComponent"
                            [deckGroupComponent]="deckGroupComponent"
                            [deckMultiRowComponent]="this"
                            [deckCard]="deckCard" 
                            class="table-row text-sm group hover:bg-ponder-linkhover hover:bg-opacity-15"
                            [ngClass]="{ 'hidden' : !shouldShowChildren() }"></magic-deck-row>
                    }
                }
            </div>
        </div>
    }
}
